<script lang="ts">
  import DiscussNavItem from './DiscussNavItem.svelte';
  import { page } from '$app/stores';
  import { ForumType, getForumPath, type ExtendedForumDataList } from '$shared/lib';
  import ExpandableNavItem from './ExpandableNavItem.svelte';
  import BubbleIcon from '$icons/messages/BubbleIcon.svelte';

  export let forums: ExtendedForumDataList;

  $: sortedForums = [...forums].sort((a, b) => a.order - b.order);
  $: publicForums = sortedForums.filter((forum) => forum.type === ForumType.PUBLIC);
  $: acceleratorForums = sortedForums.filter((forum) => forum.type === ForumType.ACCELERATOR);
  $: adminForums = sortedForums.filter((forum) => forum.type === ForumType.ADMIN);
  $: isAnyRouteActive = $page.url.pathname.startsWith('/forums');
</script>

<ExpandableNavItem title="Discuss" icon={BubbleIcon} initiallyExpanded={isAnyRouteActive}>
  <!-- Private forums -->
  {#if acceleratorForums.length > 0}
    <DiscussNavItem
      icon="LockIcon"
      name="Private Forums"
      divider={true}
      pointer={false}
      state={$page.url.pathname.startsWith('/forums/accelerator') ? 'active' : 'inactive'}
      forumType={ForumType.ACCELERATOR}
    />
    <div class="border-gray-dark-3 mx-4 flex flex-col gap-2 border-l py-1 pl-2">
      <div class="flex flex-col">
        <div class="-mt-1">
          <DiscussNavItem
            icon={'PolygonIcon'}
            name={'All Posts'}
            href={`/forums/accelerator`}
            state={$page.url.pathname === `/forums/accelerator` ? 'active' : 'inactive'}
            forumType={ForumType.ACCELERATOR}
          />
        </div>
        {#each acceleratorForums as forum}
          <DiscussNavItem
            icon="LockIcon"
            name={forum.name}
            href={getForumPath(forum)}
            state={$page.url.pathname === getForumPath(forum) ? 'active' : 'inactive'}
            forumType={ForumType.ACCELERATOR}
          />
        {/each}
      </div>
    </div>
  {/if}

  {#if acceleratorForums?.length}
    <!-- Public forums -->
    <DiscussNavItem
      icon="GlobeIcon"
      name="Public Forums"
      divider={true}
      pointer={false}
      state={$page.url.pathname.startsWith('/forums/public') ? 'active' : 'inactive'}
      forumType={ForumType.PUBLIC}
    />
  {/if}

  <div
    class="mx-4 flex flex-col"
    class:pl-2={acceleratorForums?.length}
    class:border-l={acceleratorForums?.length}
    class:border-gray-dark-3={acceleratorForums?.length}
  >
    <DiscussNavItem
      icon={'PolygonIcon'}
      name={'All Posts'}
      href={`/forums/public`}
      state={$page.url.pathname === `/forums/public` ? 'active' : 'inactive'}
      forumType={ForumType.PUBLIC}
    />
    {#if publicForums?.length}
      {#each publicForums as forum}
        <DiscussNavItem
          icon={'PolygonIconSimple'}
          name={forum.name}
          href={getForumPath(forum)}
          state={$page.url.pathname === getForumPath(forum) ? 'active' : 'inactive'}
          forumType={ForumType.PUBLIC}
        />
      {/each}
    {/if}
  </div>

  {#if adminForums.length > 0}
    <DiscussNavItem
      icon="ShieldIcon"
      name="Admin Forums"
      divider={true}
      pointer={false}
      state={$page.url.pathname.startsWith('/forums/admin') ? 'active' : 'inactive'}
      forumType={ForumType.ADMIN}
    />
    <div class="border-gray-dark-3 mx-4 flex flex-col gap-2 border-l py-1 pl-2">
      <div class="flex flex-col">
        <div class="-mt-1">
          <DiscussNavItem
            icon={'PolygonIcon'}
            name={'All Posts'}
            href={`/forums/admin`}
            state={$page.url.pathname === `/forums/admin` ? 'active' : 'inactive'}
            forumType={ForumType.ADMIN}
          />
        </div>
        {#each adminForums as forum}
          <DiscussNavItem
            icon="ShieldIcon"
            name={forum.name}
            href={getForumPath(forum)}
            state={$page.url.pathname === getForumPath(forum) ? 'active' : 'inactive'}
            forumType={ForumType.ADMIN}
          />
        {/each}
      </div>
    </div>
  {/if}
</ExpandableNavItem>
